import {
    haylardDisplayBold,
    titleBig
  } from "../../style/style.jsx";
  
import colors from "../../style/colors.scss";

import homeStyle from '../Home/homeStyle';

const pickAppStyle = theme => ({
    ...homeStyle(theme),
    dayContainer: {
      ...haylardDisplayBold,
      background: colors.darkGrey,
      cursor: 'pointer',
      color: colors.lightGrey4,
      '&:hover': {
        background: colors.grey
      }
    },
    dayContainerDisabled: {
      background: colors.lightGrey3,
      cursor : 'not-allowed',
      pointerEvents: 'none',
      color: colors.grey
    },
    daySelected: {
      background: colors.lightGrey3,
      border: '2px solid ' +  colors.darkGrey,
      color: colors.darkGrey,
      '&:hover': {
        background: colors.lightGrey3,
        color: colors.darkGrey
      }
    },
    slotContainer: {
      ...haylardDisplayBold,
      marginTop: '5px',
      marginBottom: '5px'
    },
    slotSelected:{
      background: colors.lightGrey3,
      color: colors.darkGrey,
      border: '2px solid ' +  colors.darkGrey,
      '&:hover': {
        background: colors.lightGrey3,
        color: colors.darkGrey
      }
    },
    buttonDisabled: {
      background: colors.grey
    },
    sliderContent: {
      paddingLeft: '10px',
      paddingRight: '10px',
      border: 'none',
      outline: 'none'
    },
    slider: {
      width: '100%',
      height: '100%',
      display: 'flex',
      border: 'none',
      outline: 'none'
    },
    sectionTitleUnderline : {
      ...titleBig,
      textDecoration: 'underline',
      textUnderlinePosition: 'under',
      fontSize: '22px',
      marginBottom: '3px'
    },
    noSlots: {
      fontSize: '14px',
      color: 'white !important'
    }
});

export default pickAppStyle;